import React, { useCallback, useState } from "react";
import {
  Grid,
  Button,
  Typography,
  Stack,
  MenuItem,
  Select,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  Paper,
  Box,
  Autocomplete,
} from "@mui/material";
import CustomExpandMore from "../../../common/CustomExpandMore";
import { ErrorMessage, Formik } from "formik";
import * as Yup from "yup";
import Pen from "../../../assets/images/CourseManagement/pen.svg";
import Close from "../../../assets/images/CourseManagement/close.svg";

import { useStyles } from "./styles";
import useStaff from "../../../Hooks/staff";
import { useNotification } from "../../../Hooks/notification";
import useCourse from "../../../Hooks/course";
import Loader from "../../../common/Loader";
import CustomLoader from "../../../components/Loader";
import CustomPagination from "../../../common/Pagination";
import usePagination from "../../../common/usePagination";
import DoneSharpIcon from "@mui/icons-material/DoneSharp";
import useAuthStore from "../../../Hooks/auth";
import { getStatusInBoolen, getToggleStatus } from "../../../Utils/deleteutils";
import ToggleSwitch from "../../../common/ToggleSwitch";

const columns = [
  {
    id: "notification",
    label: "Notification",
    align: "center",
  },
  {
    id: "departmentName",
    label: "Department",
    align: "center",
  },
  {
    id: "notificationDate",
    label: "Notification Date",
    align: "center",
  },
  {
    id: "status",
    label: "Status",
    align: "center",
  },
  // {
  //   id: "edit",
  //   label: "Edit",
  //   align: "center",
  // },
  {
    id: "delete",
    label: "Actions",
    align: "center",
  },
];

const Notification = (props) => {
  const classes = useStyles();
  const [addPage, setAddPage] = useState(true);
  const {
    getAllStaffNotificationAction,
    notificationData,
    addStaffNotificationAction,
    readStaffNotificationAction,
    loading,
    activeId,
    deleteStaffNotificationAction,
    setPerPageAction,
    perPage,
    setPageAction,
    setOffsetAction,
    page,
    offset,
  } = useNotification();

  const { getDepartmentAction, departmentData } = useCourse();

  const { searchStaffService, staffData, facultyData } = useStaff();

  // const [page, setPage] = useState(1);
  // const [PerPage, setPerPage] = useState(10);
  // const [offset, setOffset] = useState(0);
  const { institutionId } = useAuthStore();

  const handlePage = (e) => {
    // setPerPage(e.target.value);
    setPerPageAction(e.target.value);
    setOffsetAction(0)
    setPageAction(1)
  };

  const count =
    (notificationData &&
      Math.ceil(
        (notificationData?.totalNoOfRecordsForStaffNotification?.totalNoOfRecords || 0) / perPage
      )) ||
    0;
  // const count = notificationData && Math.ceil(notificationData?.totalNoOfRecordsForStaffNotification?.totalNoOfRecords / perPage);
  const _DATA = usePagination(notificationData?.staffNotification, perPage);

  const handleChange = useCallback(
    (e, p) => {
      // setPage(p);
      // setOffset(p * PerPage - PerPage);
      setPageAction(p);
      setOffsetAction(p * perPage - perPage);
      // _DATA.jump(p);
    },
    [perPage, page]
  );

  React.useEffect(() => {
    getDepartmentAction({
      department: {
        institutionId,
      },
    });
  }, []);

  React.useEffect(() => {
    getAllStaffNotificationAction({
      limit: perPage,
      offset: offset,
      institutionId: institutionId,
    });
  }, [perPage, offset]);

  React.useEffect(() => {
    const abortController = new AbortController();
    let staffSearch = {
      idDepartment: "",
      regNumber: "",
      sortBy: "asc",
      orderBy: "created_at",
      limit: 100,
      offset: 0,
      institutionId,
    };

    searchStaffService({ staffSearch, signal: abortController.signal });
    return () => {
      abortController.abort();
    };
  }, []);

  const notificationSchema = Yup.object().shape({
    notification: Yup.string().required("* Please enter message"),
    // departmentName: Yup.string().required("* Please enter the departmentName "),
    idDepartment: Yup.string().required("* Please select department ID"),
    idFaculties: Yup.array().required("* Please select the target audience"),
  });

  const initValues = {
    idDepartment: "",
    notification: "",
    departmentName: "",
    idFaculties: [],
    institutionId,
  };

  const editList = () => {
    setAddPage(false);
    props.listPage(false);
  };
  return (
    <>
      {loading && <Loader />}
      <Grid container className={classes.circularList}>
        <Grid item lg={8} xs={12}>
          <Stack className={classes.align}>
            <Formik
              validationSchema={notificationSchema}
              initialValues={initValues}
              validateOnBlur={false}
              validateOnChange={false}
              onSubmit={(values, { resetForm }) => {
                addStaffNotificationAction(values);
                resetForm({ values: "" });
              }}
            >
              {(formik) => {
                const {
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  values,
                  setFieldValue,
                } = formik;
                return (
                  <form onSubmit={handleSubmit}>
                    <Stack>
                      <Typography className={classes.title} sx={{ pb: 2 }}>
                        Add Notification
                      </Typography>
                    </Stack>
                    <Stack sx={{ pb: 3 }}>
                      <Typography
                        sx={{ pb: 1 }}
                        className={classes.input_label}
                      >
                        Message
                      </Typography>
                      <TextField
                        id="notification"
                        name="notification"
                        placeholder="Notification"
                        className={
                          errors.notification && touched.notification
                            ? classes.inputError
                            : classes.inputNoError
                        }
                        onChange={handleChange}
                        value={values.notification}
                      />
                      <ErrorMessage
                        name="notification"
                        component="span"
                        className={classes.error}
                      />
                    </Stack>
                    {/* <Stack sx={{ pb: 3 }}>
                      <Typography
                        sx={{ pb: 1 }}
                        className={classes.input_label}
                      >
                        Department Name
                      </Typography>
                      <TextField
                        id="departmentName"
                        name="departmentName"
                        placeholder="Enter department name"
                        className={
                          errors.departmentName && touched.departmentName
                            ? classes.inputError
                            : classes.inputNoError
                        }
                        type="text"
                        onChange={handleChange}
                        value={values.departmentName}
                      />
                      <ErrorMessage
                        name="departmentName"
                        component="span"
                        className={classes.error}
                      />
                    </Stack> */}
                    <Stack sx={{ pb: 3 }}>
                      <Typography
                        sx={{ pb: 1 }}
                        className={classes.input_label}
                      >
                        Department
                      </Typography>

                      <Select
                        id="idDepartment"
                        name="idDepartment"
                        className={
                          errors.idDepartment && touched.idDepartment
                            ? classes.inputError
                            : classes.inputNoError
                        }
                        value={values.idDepartment}
                        onChange={handleChange}
                        placeholder="what's your favourite car?"
                        IconComponent={CustomExpandMore}
                        displayEmpty
                      >
                        <MenuItem disabled value="">
                          <span>Select Department</span>
                        </MenuItem>
                        {typeof departmentData !== "undefined"
                          ? departmentData?.map((_el) => (
                            <MenuItem value={_el.id}>{_el.name}</MenuItem>
                          ))
                          : null}
                      </Select>
                      <ErrorMessage
                        name="idDepartment"
                        component="span"
                        className={classes.error}
                      />
                    </Stack>
                    <Stack sx={{ pb: 3 }}>
                      <Typography
                        sx={{ pb: 1 }}
                        className={classes.input_label}
                      >
                        Target Audience
                      </Typography>
                      <Autocomplete
                        multiple
                        id="idFaculties"
                        name="idFaculties"
                        options={staffData?.facultySearchResult || []}
                        getOptionLabel={(option) =>
                          option.firstName + " " + option.lastName
                        }
                        popupIcon={<CustomExpandMore />}
                        onChange={(e, newValue) => {
                          const idArray = [];
                          newValue.map((_el) =>
                            idArray.push({ id: _el.idFaculty })
                          );
                          setFieldValue("idFaculties", idArray);
                        }}
                        filterSelectedOptions
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Select Faculties"
                          />
                        )}
                      />
                      <ErrorMessage
                        name="idFaculties"
                        component="span"
                        className={classes.error}
                      />
                    </Stack>
                    <Button
                      type="submit"
                      sx={{
                        width: "50%",
                        px: 1,
                        py: 2,
                        borderRadius: "50px",
                        fontSize: "15px",
                      }}
                      className={classes.submit_btn}
                    >
                      Add notification
                    </Button>
                  </form>
                );
              }}
            </Formik>
          </Stack>
          <Stack sx={{ my: 4 }}>
            <Box sx={{ width: "100%" }}>
              <Paper
                sx={{
                  width: "100%",
                  borderRadius: "20px",
                  filter: "drop-shadow(0px 4px 40px rgba(0, 0, 0, 0.08))",
                  boxShadow: "none",
                }}
              >
                <Stack sx={{ p: 4 }}>
                  <TableContainer sx={{ maxHeight: "440px" }}>
                    <Table
                      aria-label="sticky table"
                      className={classes.root}
                      style={{ padding: 0 }}
                      stickyHeader
                    >
                      <TableHead>
                        <TableRow classes={{ root: classes.thead }}>
                          {columns.map((column) => (
                            <TableCell
                              key={column.id}
                              align={column.align}
                              style={{
                                minWidth: column.minWidth,
                                paddingLeft: column.paddingLeft,
                              }}
                              classes={{ root: classes.columnData }}
                            >
                              {column.label}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody classes={{ root: classes.tBody }}>
                        {notificationData?.staffNotification?.length > 0 ? (
                         notificationData?.staffNotification?.map((_el, index) => ( 
                              <TableRow role="checkbox" tabIndex={-1} key={index}>
                                {columns.map((column) => {
                                  return (
                                    <TableCell
                                      key={column.id}
                                      align={column.align}
                                    >
                                      {column.id === "notification" ? (
                                        _el.notification
                                      ) : column.id === "departmentName" ? (
                                        _el.idDepartment &&
                                        departmentData &&
                                        departmentData?.filter(
                                          (d) => d.id == _el.idDepartment
                                        )[0].name
                                      ) : column.id === "notificationDate" ? (
                                        _el.notificationDate
                                      ) : column.id === "status" ? (
                                        <Stack
                                          sx={{
                                            justifyContent: "center",
                                            alignItems: "center",
                                          }}
                                        >
                                          {loading && activeId === _el.id ? (
                                            <CustomLoader />
                                          ) : (
                                            <Typography
                                              sx={{ fontFamily: "inter" }}
                                              role="button"
                                              onClick={() => {
                                                readStaffNotificationAction(
                                                  _el.id
                                                );
                                              }}
                                            >
                                              {_el.status === "unread" ? (
                                                "Mark as read"
                                              ) : (
                                                <DoneSharpIcon />
                                              )}
                                            </Typography>
                                          )}
                                        </Stack>
                                      ) : column.id === "edit" ? (
                                        <Stack
                                          sx={{
                                            alignItems: "center",
                                            cursor: "pointer",
                                          }}
                                          onClick={editList}
                                        >
                                          <img src={Pen} alt="pen" />
                                        </Stack>
                                      ) : (
                                        <Stack
                                          sx={{
                                            alignItems: "center",
                                            cursor: "pointer",
                                          }}
                                          onClick={() =>
                                            deleteStaffNotificationAction({
                                              notificationGroupId:
                                                _el.notificationGroupId,
                                              deleted: getToggleStatus(
                                                parseInt(_el.deleted)
                                              ),
                                            })
                                          }
                                        >
                                          <ToggleSwitch
                                            defaultChecked
                                            checked={getStatusInBoolen(
                                              parseInt(_el.deleted)
                                            )}
                                          />
                                        </Stack>
                                      )}
                                    </TableCell>
                                  );
                                })}
                              </TableRow>
                            ))
                        ) : (
                          <TableRow>
                            <TableCell
                              colSpan={columns.length}
                              sx={{ borderBottom: "none" }}
                            >
                              <Stack
                                sx={{
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                No Data
                              </Stack>
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  {notificationData?.totalNoOfRecordsForStaffNotification?.totalNoOfRecords > 10 && (
                    <CustomPagination
                      count={count}
                      page={page}
                      onPageChange={handleChange}
                      handlePage={handlePage}
                      perPage={perPage}
                    />
                  )}
                </Stack>
              </Paper>
            </Box>
          </Stack>
        </Grid>
      </Grid>
    </>
  );
};

export default Notification;
